import {getRequesterId} from "./helper/getRequesterId";

const actions = {
    LIST_READ_LISTS_ADD_TO_QUEUE: 'LIST_READ_LISTS_ADD_QUEUE',
    LIST_READ_LISTS_REQUEST: 'LIST_READ_LISTS_REQUEST',
    LIST_READ_LISTS_SUCCESS: 'LIST_READ_LISTS_SUCCESS',
    LIST_READ_LISTS_FAILURE: 'LIST_READ_LISTS_FAILURE',
    LIST_RESET_LISTS: 'LIST_RESET_LISTS',
    LIST_READ_RECONCILIATIONS_REQUEST: 'LIST_READ_RECONCILIATIONS_REQUEST',
    LIST_READ_RECONCILIATIONS_SUCCESS: 'LIST_READ_RECONCILIATIONS_SUCCESS',
    LIST_READ_RECONCILIATIONS_FAILURE: 'LIST_READ_RECONCILIATIONS_FAILURE',
    LIST_ADD_PRODUCT: 'LIST_ADD_PRODUCT',
    LIST_ADD_CONTACT: 'LIST_ADD_CONTACT',
    LIST_REPLACE_CONTACT: 'LIST_REPLACE_CONTACT',
    LIST_REPLACE_CONTACT_ADDRESSES: 'LIST_REPLACE_CONTACT_ADDRESSES',
    LIST_REPLACE_CONTACT_PERSONS: 'LIST_REPLACE_CONTACT_PERSONS',
    LIST_REPLACE_PRODUCT_DETAIL_LIST: 'LIST_REPLACE_PRODUCT_DETAIL_LIST',
    LIST_MERGE_PRODUCT_DETAIL_LIST: 'LIST_MERGE_PRODUCT_DETAIL_LIST',
    LIST_ADD_ACCOUNT: 'LIST_ADD_ACCOUNT',
    LIST_ADD_TERM: 'LIST_ADD_TERM',
    LIST_ADD_LOCATION: 'LIST_ADD_LOCATION',
    LIST_ADD_PAYMENT_METHOD: 'LIST_ADD_PAYMENT_METHOD',
    LIST_ADD_PRICE_LEVEL: 'LIST_ADD_PRICE_LEVEL',
    LIST_ADD_TAG: 'LIST_ADD_TAG',
    LIST_ADD_TAG_GROUP: 'LIST_ADD_TAG_GROUP',
    LIST_ADD_NUMBER_FORMAT: 'LIST_ADD_NUMBER_FORMAT',
    LIST_ADD_FLOW_STREAM: 'LIST_ADD_FLOW_STREAM',
    LIST_CHANGE_FLOW_STEAMS: 'LIST_CHANGE_FLOW_STEAMS', // for changing the flow streams list

    // LIST_UPDATE_LIMITS: 'LIST_UPDATE_LIMITS',
    READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST: 'READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST',

    // for list caching mechanism
    ADD_ROUTED_PATH: 'ADD_ROUTED_PATH',

    readLists: (lists, params = {}, showSpinner = true, forceMode = false) => ({
        type: actions.LIST_READ_LISTS_REQUEST,
        lists,
        params,
        requesterId: getRequesterId(),
        showSpinner,
        forceMode,
    }),
    updateLists: (lists, params = {}, showSpinner = true) => ({
        type: actions.LIST_READ_LISTS_REQUEST,
        lists,
        params,
        requesterId: getRequesterId(),
        showSpinner,
    }),
    resetLists: (lists = []) => ({
        type: actions.LIST_RESET_LISTS,
        lists,
    }),
    readReconciliations: request => ({
        type: actions.LIST_READ_RECONCILIATIONS_REQUEST,
        request,
    }),
    addContact: contact => ({
        type: actions.LIST_ADD_CONTACT,
        contact,
    }),
    replaceContact: contact => ({
        type: actions.LIST_REPLACE_CONTACT,
        contact,
    }),
    replaceContactAddresses: contactAddresses => ({
        type: actions.LIST_REPLACE_CONTACT_ADDRESSES,
        contactAddresses, // [{},...]
    }),
    replaceContactPersons: contactPersons => ({
        type: actions.LIST_REPLACE_CONTACT_PERSONS,
        contactPersons, // [{},...]
    }),
    replaceProductDetailList: productDetailList => ({
        type: actions.LIST_REPLACE_PRODUCT_DETAIL_LIST,
        productDetailList, // [{},...]
    }),
    addProduct: product => ({
        type: actions.LIST_ADD_PRODUCT,
        product,
    }),
    addAccount: account => ({
        type: actions.LIST_ADD_ACCOUNT,
        account,
    }),
    addTerm: term => ({
        type: actions.LIST_ADD_TERM,
        term,
    }),
    addLocation: location => ({
        type: actions.LIST_ADD_LOCATION,
        location,
    }),
    addPaymentMethod: paymentMethod => ({
        type: actions.LIST_ADD_PAYMENT_METHOD,
        paymentMethod,
    }),
    addPriceLevel: priceLevel => ({
        type: actions.LIST_ADD_PRICE_LEVEL,
        priceLevel,
    }),
    // updateLimits is now replaced with updateStorageUtilisation
    // updateLimits: (key, limits) => ({
    //     type: actions.LIST_UPDATE_LIMITS,
    //     key,
    //     limits,
    // }),
    addNumberFormat: numberFormat => ({
        type: actions.LIST_ADD_NUMBER_FORMAT,
        numberFormat,
    }),
    addTag: tag => ({
        type: actions.LIST_ADD_TAG,
        tag,
    }),
    addTagGroup: tagGroup => ({
        type: actions.LIST_ADD_TAG_GROUP,
        tagGroup,
    }),
    addFlowStream: flowStream => ({
        type: actions.LIST_ADD_FLOW_STREAM,
        flowStream,
    }),
    changeFlowStreams: flowStreams => ({
        type: actions.LIST_CHANGE_FLOW_STEAMS,
        flowStreams,
    }),
    readAllProductAndProductDetailList: productType => ({
        type: actions.READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST,
        productType,
    }),
    addRoutedPath: pathname => ({
        type: actions.ADD_ROUTED_PATH,
        pathname,
    }),
};
export default actions;
